<template>
  <form @submit.prevent="formAction">
    <card-component
      :title="`Cadastrar Pessoa`"
      icon="ballot"
    >
      <b-field label="Dados Pessoais" horizontal>
        <b-field label="Nome*">
          <b-input
            v-model="form.pessoa.nome"
            icon="account-circle-outline"
            placeholder="Nome*"
            name="tipoVeiculo"
            required
          />
        </b-field>
      </b-field>
      <b-field horizontal>
        <b-field label="Estrangeiro ?">
          <b-select
            v-model="form.pessoa.estrangeiro"
            placeholder="Estrangeiro"
            expanded
            icon="card-bulleted-outline"
          >
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </b-select>
        </b-field>

        <b-field label="CPF*" v-if="!form.pessoa.estrangeiro">
          <b-input
            v-model="form.pessoa.cpf"
            icon="card-bulleted-outline"
            placeholder="CPF*"
            name="CPF"
            v-mask="'###.###.###-##'"
            required
          />
        </b-field>
        <b-field label="RG" v-if="!form.pessoa.estrangeiro">
          <b-input
            v-model="form.pessoa.rg"
            icon="card-bulleted-outline"
            placeholder="RG"
            name="RG"
            type="number"
          />
        </b-field>
        <b-field label="Orgão Expedidor" v-if="!form.pessoa.estrangeiro">
          <b-input
            v-model="form.pessoa.orgaoExpedidor"
            icon="card-bulleted-outline"
            placeholder="Orgão Expedidor"
            name="orgaoExp"
          />
        </b-field>
      </b-field>

      <b-field horizontal>
        <b-field label="Passaporte">
          <b-input
            v-model="form.pessoa.passaporte"
            icon="card-bulleted-outline"
            placeholder="Passaporte"
            data-js="passaporte"
            name="passaporte"
          />
        </b-field>
        <b-field label="CNH*">
          <b-input
            v-model="form.pessoa.cnh"
            icon="card-bulleted-outline"
            placeholder="CNH*"
            name="CNH"
            data-js="cnh"
            :required="false"
          />
        </b-field>
        <b-field label="Data Validade CNH">
          <input
            type="date"
            v-model="form.pessoa.validadeCnh"
            class="input"
            pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
          />
        </b-field>
        <b-field label="Código do Cartão">
          <b-input
            v-model="form.pessoa.numeroCartao"
            icon="card-bulleted-outline"
            placeholder="Código do Cartão"
            name="codCartao"
          />
        </b-field>
      </b-field>

      <b-field horizontal>
        <b-field label="Crachá">
          <b-input
            v-model="form.pessoa.cracha"
            icon="card-bulleted-outline"
            placeholder="Crachá"
            name="cracha"
          />
        </b-field>
        <b-field label="Telefone">
          <b-input
            v-model="form.pessoa.telefone"
            icon="phone"
            placeholder="Telefone"
            name="telefone"
            v-mask="'(##) ####-####'"
          />
        </b-field>
        <b-field label="Celular">
          <b-input
            v-model="form.pessoa.celular"
            icon="cellphone-iphone"
            placeholder="Celular"
            name="celular"
            v-mask="'(##) #####-####'"
          />
        </b-field>
        <b-field label="Email">
          <b-input
            v-model="form.pessoa.email"
            icon="email-outline"
            placeholder="E-mail"
            name="email"
            type="email"
          />
        </b-field>
      </b-field>

      <b-field horizontal>
        <b-field label="Cargo" class="is">
          <b-input
            v-model="form.pessoa.cargo"
            icon="account-tie-outline"
            placeholder="Cargo"
            name="cargo"
          />
        </b-field>
      </b-field>
      <b-field horizontal>
        <b-field>
          <div class="control">
            <b-button native-type="submit" type="is-info" :loading="isLoading">
              Salvar
            </b-button>
          </div>
        </b-field>
      </b-field>
    </card-component>
  </form>
</template>

<script>
import { defineComponent } from "vue";

import CardComponent from "@/components/Cards/CardComponent.vue";

import PessoaService from "@/services/PessoaService.js";
import storage from "@/mixins/storage";

export default defineComponent({
  name: "PessoaForm",
  components: {
    CardComponent,
  },
  data() {
    return {
      form: {
        pessoa: {
          dataInicioAcesso: null,
        },
      },
      estados: [
        "AC",
        "AL",
        "AP",
        "AM",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MT",
        "MS",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RS",
        "RO",
        "RR",
        "SC",
        "SP",
        "SE",
        "TO",
      ],
      municipios: [],
      isGetting: false,
      isLoading: false,
    };
  },
  computed: {
    getMunicipios() {
      return this.municipios.filter(
        (municipio) => municipio.uf === this.form.pessoa.uf
      );
    },
  },
  mounted() {
    this.loadResources();
    if (this.$route.params.id) {
      this.loadPessoa();
    }
  },
  methods: {
    async loadResources() {
      this.isGetting = true;
      try {
        const [municipiosRes, empresasRes] = await Promise.all([
          this.$http.get("/municipios"),
          this.$http.get("/empresas?page=0&size=1000&orderBy=razaoSocial,ASC"),
        ]);

        this.municipios = municipiosRes.data;
        this.empresas = empresasRes.data.content;
        this.handleUserPermissions();
      } finally {
        this.isGetting = false;
      }
    },

    handleUserPermissions() {
      const role = storage.methods.getRole();
      if (!["ROLE_CADASTRO", "ROLE_CONTRATANTE", "ROLE_ADMIN"].includes(role)) {
        const userEmpresa = storage.methods.getEmpresa();
        const empresa = this.empresas.find(
          (e) => e.razaoSocial === userEmpresa
        );
        if (empresa) this.form.pessoa.idEmpresa = empresa.id;
      }
    },

    async loadPessoa() {
      try {
        const response = await PessoaService.getPessoa(this.$route.params.id);
        this.form.pessoa = {
          ...response.data,
          idEmpresa: response.data.empresa?.id,
          idMunicipio: response.data.municipio?.id,
        };
      } catch (error) {
        this.handleError(error, "Erro ao carregar dados da pessoa");
      }
    },

    async formAction() {
      this.isLoading = true;
      console.log("form:", this.form.pessoa);
      try {
        const action = this.$route.params.id
          ? PessoaService.putPessoa(this.$route.params.id, this.form.pessoa)
          : PessoaService.postPessoa(this.form.pessoa);

        const response = await action;
        this.handleSuccess(response);
      } catch (error) {
        this.handleError(error, "Erro ao salvar pessoa");
      } finally {
        this.isLoading = false;
      }
    },
    handleSuccess(response) {
      this.$buefy.toast.open({
        message: this.$route.params.id
          ? "Pessoa Atualizada!"
          : "Pessoa Cadastrada!",
        type: "is-success",
      });

      const redirectPath = "/pessoas?page=1&orderBy=id,DESC"

      this.$router.push(redirectPath);
    },

    handleError(error, defaultMsg) {
      const message = error.response?.data?.message || defaultMsg;
      this.$buefy.toast.open({ message, type: "is-danger" });
    },
  },
});
</script>
